import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import readExcel from '../../modules/readExcel';
import { XTNA } from '../xtna';
import PersonalDataForm from './PersonalDataForm.jsx';

const excelSchema = {
  sheetNum: 5,
  cells: {
    name: 'BC4', company: 'BC5', date: 'BC6', age: 'BC7',
    NX: 'BA11', NT: 'BB11', NN: 'BC11', NA: 'BD11', AX: 'BA12', AT: 'BB12', AN: 'BC12', AA: 'BD12'
  }
};

export default class ExcelDataExtractor extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      errorMessage: ''
    };
  }
  render() {
    return (
      <div className='form-inline' style={{ marginBottom: '10px' }}>
        <label>Cargar datos de Excel:</label>
        <input ref='fileInput' type='file' accept='.xlsx' onChange={this.handleExcelSubmission} />
        <span style={{ color: 'red' }}>{this.state.errorMessage}</span>
      </div>
    );
  }
  handleExcelSubmission() {
    this.setState({ errorMessage: '' });
    const files = this.refs.fileInput.getDOMNode().files;

    if (files.length === 0) {
      return;
    }

    const file = files[0];
    const cells = R.toPairs(excelSchema.cells).map(R.tail);
    readExcel(cells, excelSchema.sheetNum, file)
    .then((data) => {
      if (R.any(R.isNil, R.toPairs(data).map(R.compose(R.head, R.tail)))) {
        return this.setState({errorMessage: 'Archivo inválido.'});
      }

      const formattedData = R.compose(R.fromPairs, R.map((pair) => [R.head(pair), data[R.head(R.tail(pair))]]), R.toPairs)(excelSchema.cells);
      
      formattedData.date = moment.unix((parseInt(formattedData.date) - 25568)*60*60*24 - 19*60*60);
      [...XTNA.props(), 'age'].forEach((prop) => formattedData[prop] = parseInt(formattedData[prop]));

      const xtna = R.pick(XTNA.props(), formattedData);
      const personal = R.pick(['name', 'company', 'date', 'age'], formattedData);

      this.props.onChange({
        xtna: R.merge(xtna, { valid: XTNA.validForm(xtna) }),
        personal: R.merge(personal, { valid: PersonalDataForm.validForm(personal) })
      });
    }, () => this.setState({errorMessage: 'Archivo inválido.'}));
  }
}



// WEBPACK FOOTER //
// ./src/App/reports/ExcelDataExtractor.jsx